import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Generic role-based widget landing page used across org modules.
 * Pass:
 *   title: hub headline
 *   subtitle: descriptive line under title
 *   widgets: [{ label, description, to, icon: LucideIcon, count?, accent? }]
 */
export default function WidgetHub({ title, subtitle, widgets, footer = null, testid = "widget-hub" }) {
  return (
    <div className="p-8 space-y-6" data-testid={testid}>
      <div>
        <div className="label-overline">{subtitle ? "Module" : null}</div>
        <h1 className="font-display text-3xl font-black mt-1">{title}</h1>
        {subtitle ? <p className="text-muted-foreground mt-2 max-w-xl">{subtitle}</p> : null}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {widgets.map((w) => {
          const Icon = w.icon;
          const content = (
            <div
              className="group relative h-full surface-card p-5 hover:-translate-y-1 hover:shadow-lg transition-all cursor-pointer overflow-hidden"
              data-testid={`widget-${(w.testid || w.label).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className={`absolute -top-12 -right-12 w-32 h-32 rounded-full ${w.accent || "bg-orange-500/5"} group-hover:scale-125 transition-transform`} />
              <div className="relative flex items-start justify-between">
                <div className={`w-10 h-10 rounded-xl ${w.accent || "bg-orange-500/10"} grid place-items-center`}>
                  {Icon ? <Icon className="w-5 h-5 text-foreground" /> : null}
                </div>
                <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors" />
              </div>
              <div className="relative mt-4">
                <div className="font-display text-lg font-black leading-tight">{w.label}</div>
                {w.description ? <div className="text-xs text-muted-foreground mt-1">{w.description}</div> : null}
                {w.count !== undefined ? <div className="font-display text-2xl font-black mt-3">{w.count}</div> : null}
              </div>
            </div>
          );
          return w.to ? <Link key={w.label} to={w.to}>{content}</Link> : <div key={w.label}>{content}</div>;
        })}
      </div>

      {footer}
    </div>
  );
}
